<div>
	<mat-card class="sdp-success-card">{{ "message.account.invalidCode" | translate }}</mat-card>
	<span (click)="showSignInForm()" class="bh-fake-anchor sdp-login-small-links">{{ "registration.form.back.signIn" | translate }}?</span>
	<div class="sdp-form-buttons-container">
		<button mat-raised-button color="primary" type="button" (click)="resendConfirmationEmail()" [disabled]="registrationService.isLoaderVisible">{{ "form.label.resendConfirmation" | translate }}</button>
	</div>
	<div class="sdp-invalid-code-error-container">
		<mat-card *ngIf="errorMessage" class="sdp-error-card">{{ errorMessage | translate }}</mat-card>
	</div>
</div>